module.exports = __webpack_public_path__ + "static/img/success-circle-check-icon.88f0587e.png";